import { Flex, Text } from '@scale/scaleui-radix';
import { AuditRubricCriterion } from '@scale/shared-types';

export const CriterionQuestionText = ({ criterion }: { criterion: AuditRubricCriterion }) => {
  return (
    <Flex direction="column" gap="1">
      <Text weight="medium">{criterion.questionText}</Text>
      {criterion.questionDescription && (
        <Text size="1" color="neutral" className="italic">
          {criterion.questionDescription}
        </Text>
      )}
    </Flex>
  );
};
